import { clsx } from "clsx";

type StatusBadgeProps = {
  value: string;
};

export function StatusBadge({ value }: StatusBadgeProps) {
  const normalized = value.toLowerCase();

  return (
    <span
      className={clsx(
        "status-badge",
        normalized.includes("approved") || normalized.includes("succeeded")
          ? "border-lime-400/30 bg-lime-400/10 text-lime-200"
          : normalized.includes("failed") || normalized.includes("rejected")
            ? "border-red-400/30 bg-red-500/10 text-red-200"
            : normalized.includes("running") ||
                normalized.includes("verifying") ||
                normalized.includes("pending")
              ? "border-amber-400/30 bg-amber-400/10 text-amber-100"
              : "border-white/10 bg-white/5 text-neutral-300"
      )}
    >
      {value.replace(/_/g, " ")}
    </span>
  );
}
